module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity-list"
  }, [_c('el-row', {
    staticClass: "mb-2",
    staticStyle: {
      "border-bottom": "1px solid #ebeef5",
      "padding-bottom": "6px"
    },
    attrs: {
      "gutter": 20,
      "type": "flex",
      "justify": "space-between",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h3', {
    staticClass: "text-muted"
  }, [_vm._v("Recent Activities")])]), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 12
    }
  }, [(_vm.activities.length > 0) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.removeAllActivity(_vm.activities)
      }
    }
  }, [_vm._v("\n        Clear All\n      ")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.activities.length === 0) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "empty-message"
  }, [_c('el-icon', {
    staticClass: "el-icon-info",
    attrs: {
      "size": 30
    }
  }), _vm._v(" "), _c('p', [_vm._v("No activities found")]), _vm._v(" "), _c('p', {
    staticClass: "empty-subtext",
    staticStyle: {
      "color": "#c0c4cc",
      "font-size": "12px"
    }
  }, [_vm._v("\n          Your activities will appear here once added\n        ")])], 1)])], 1) : _c('div', {
    staticClass: "scroll-container"
  }, _vm._l((_vm.activities), function(row, index) {
    return _c('div', {
      key: row.id || index,
      staticClass: "activity-item"
    }, [_c('el-row', {
      attrs: {
        "type": "flex",
        "justify": "space-between",
        "align": "middle"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 16
      }
    }, [_c('span', [_vm._v(_vm._s(index + 1) + ". " + _vm._s(row.title))]), _vm._v(" "), (row.error) ? _c('el-tooltip', {
      attrs: {
        "content": row.error
      }
    }, [_c('i', {
      staticClass: "el-icon-warning",
      staticStyle: {
        "color": "#ff4d4f",
        "cursor": "pointer"
      }
    })]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      staticClass: "text-right activity-meta text-muted",
      attrs: {
        "span": 8
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.formatRelativeTime(row.date_created || row.timestamp)))]), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "content": "Delete",
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "el-icon-delete",
      style: ({
        cursor: 'pointer',
        color: _vm.hoverDelete ? '#ff4d4f' : 'inherit'
      }),
      on: {
        "mouseover": function($event) {
          _vm.hoverDelete = true
        },
        "mouseleave": function($event) {
          _vm.hoverDelete = false
        },
        "click": function($event) {
          return _vm.removeActivity(row)
        }
      }
    })])], 1)], 1), _vm._v(" "), (row.activity_type === 1) ? _c('el-progress', {
      staticClass: "mt-1",
      attrs: {
        "percentage": _vm.calculatePercentage(row),
        "status": _vm.getProgressStatus(row),
        "show-text": ""
      }
    }) : _vm._e()], 1)
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4441a87b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/activities/ActivitiesList.vue
// module id = 3252
// module chunks = 3